import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import { loginFormSelectorState } from "my-hr/states/login-form-selector-state";

export const useMyHrLoginFormSelectorState = () => {
  const state = useRecoilValue(loginFormSelectorState);
  const setState = useSetRecoilState(loginFormSelectorState);
  const resetState = useResetRecoilState(loginFormSelectorState);

  return { state, setState, resetState };
};

export default useMyHrLoginFormSelectorState;
